import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import '../../../styles/index.scss';
import { Footer, Header } from '..';

import styles from './PastoralVisitLayout.module.scss';

const PastoralVisitLayout = React.memo(({ children }) => {
  return (
    <>
      <div className={classNames('app h-100 d-flex flex-column', styles.self)}>
        <Header description="Wsparcie parafii - ofiara online" />

        <main className="container-lg flex-grow-1 flex-shrink-0 d-flex flex-column mt-5">
          <h1 className="el-h4 mb-4">Formularz zgłoszeniowy wizyty duszpasterskiej</h1>

          {children}
        </main>

        <div className={styles.footerWrapper}>
          <Footer isWhite />
        </div>
      </div>
    </>
  );
});

PastoralVisitLayout.propTypes = {
  children: PropTypes.node,
};

export default PastoralVisitLayout;
